import { useNow } from "@/hooks/useNow";
import { useQuery } from "@apollo/client";
import { useOrg } from "@/hooks/useOrg";
import { HIDDEN_ACTIONS_COUNT } from "@/api/queries/hiddenActionsCount";
import { getDateString } from "@/util/dateUtils";

export const useHiddenActionsCount = (userId?: string) => {
  const { org, loading: orgLoading } = useOrg();
  const now = useNow();
  const todaysDate = new Date(now);
  console.log("USER hidden actions count userId: ", userId);

  const { data, loading, error } = useQuery(HIDDEN_ACTIONS_COUNT, {
    variables: {
      orgId: org?.id || "",
      date: getDateString(todaysDate),
      userId: userId || "",
    },
    skip: !org?.id || !userId,
  });

  let count: number | null = null;
  if (data?.node?.__typename === "User") {
    count = data?.node.actions?.totalCount || null;
  }
  return { count, loading: loading || orgLoading, error };
};
